import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const getAgendarJardin = 'validacion/getAgendaJardin/'
const getEstadoValidacion = 'validacion/getEstadoValidacion/'
const getActaValidacion = 'validacion/getActaValidacion/'
const crearEvaluacionValidacion = 'validacion/crearEvaluacionValidacion/'
const getEvaluacionValidacion = 'validacion/getEvaluacionValidacion/'
const getFirmaActa = 'validacion/getFirmaActa/'
const getDataInformeValidacion = 'validacion/getDataInformeValidacion/';
const registrarVistaInformeResultados = 'validacion/registrarVistaInformeResultados/';
const finalizarApelacion = 'validacion/finalizarApelacion/';



const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  

@Injectable({
  providedIn: 'root'
})
export class ValidacionService {
  

  constructor(private http:HttpClient) { }
 
  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

  API_POST_getAgendarJardin(idJardin:number): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getAgendarJardin + idJardin, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getEstadoValidacion(idJardinPeriodo: number): Observable<any> {
    return this.http.post(environment.apiEndpoint + getEstadoValidacion + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  API_POST_getActaValidacion(idJardinPeriodo): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getActaValidacion + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_crearEvaluacionValidacion(idJardinPeriodo, validacionData): Observable<any>{    
    return this.http.post(environment.apiEndpoint + crearEvaluacionValidacion + idJardinPeriodo, validacionData, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  API_POST_getEvaluacionValidacion(idJardinPeriodo): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getEvaluacionValidacion + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  
  API_POST_getFirmaActa(idJardinPeriodo): Observable<any>{    
    return this.http.post(environment.apiEndpoint + getFirmaActa + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  API_POST_getDataInformeValidacion(idJardinPeriodo: number): Observable<any> {
    return this.http.post(environment.apiEndpoint + getDataInformeValidacion + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_registrarVistaInformeResultados(idJardinPeriodo: number): Observable<any> {
    return this.http.post(environment.apiEndpoint + registrarVistaInformeResultados + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarApelacion(idJardinPeriodo: any): Observable<any> {
    return this.http.post(environment.apiEndpoint + finalizarApelacion + idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

}
